export default __webpack_public_path__ + "static/media/188.7a973c00.png";